import React from "react";
import FilterPopup from "../FilterPopup";
import { Button } from "semantic-ui-react";

interface Props {
  title: string
  onApply: () => void
  minHeight: number
  width: number
  open: boolean
  onOpen: () => void
  onClose: () => void
}

const MultiPickerFilterPopup = (props: React.PropsWithChildren<Props>) => {
  return <FilterPopup
    filterButtonLabel={props.title}
    content={<div
      style={{ minHeight: props.minHeight }}
      className="flex-column gap"
    >

      {props.children}

      <Button primary onClick={props.onApply} fluid>
        {RESX.SelectionManager.Apply}
      </Button>
    </div>}
    width={props.width}
    open={props.open}
    onClose={props.onClose}
    onOpen={props.onOpen}
  />;
};

export default MultiPickerFilterPopup;